<template>
  <Tooltip side="bottom" :side-offset="8" :delay-duration="400">
    <button
      type="button"
      :class="
        cn(
          'text-accent-400 hover:bg-neutral-50/[0.12] py-2 px-3 inline-flex relative',
          isCommentSectionOpen && 'bg-neutral-50/[0.12]',
          rounded && 'rounded'
        )
      "
      @click="onOpenComments"
    >
      <MessagesSquare class="size-6" />
      <span
        v-if="!hasReadAllComments"
        class="size-3 bg-white inline-block absolute top-1.5 right-1.5 rounded-full border-[2px] border-black"
      />
    </button>

    <template #content>
      <p>Comments</p>
    </template>
  </Tooltip>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { MessagesSquare } from 'lucide-vue-next';
import { cn } from '@ui/utils';
import { Tooltip } from '@ui/components/tooltip';

defineProps({
  rounded: Boolean,
});

const emits = defineEmits(['callback']);

const store = useStore();

const hasReadAllComments = computed(
  () => store.getters['project/config/comments/getReadAll']
);

const isCommentSectionOpen = computed(
  () => store.getters['application/getCommentSection']
);

const onOpenComments = () => {
  store.dispatch('application/setCommentSection', {
    value: !isCommentSectionOpen.value,
  });
  emits('callback');
};
</script>
